



















































import Vue from 'vue'

export default Vue.extend({
  name: 'SettingTooltip',
  props: {
    text: {
      type: String,
      required: true
    },
    url: {
      type: String,
      default: null
    }
  },
  methods: {
    openHelp () {
      if (this.url) {
        window.open(this.url, '_blank', 'noopener')
      }
    }
  }
})
